import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import loginEn from './translations/login/login_en.json';
import loginCn from './translations/login/login_cn.json'
import icplEn from './translations/icpl/icpl_en.json';
import icplCn from './translations/icpl/icpl_cn.json'

export const LocalizationLng = {
    en: 'en',
    cn: 'cn'
}

i18n.use(initReactI18next)
    .init({
        lng: LocalizationLng.en,
        resources: {
            en: {
                translation: {
                    login: loginEn,
                    icpl: icplEn
                }
            },
            cn: {
                translation: {
                    login: loginCn,
                    icpl: icplCn
                }
            }
        },
        fallbackLng: LocalizationLng.en,
    });

export default i18n;